import { useAirModal } from "@air/provider-modal";
import { itemIsSelectedSelector, selectedItemsCountSelector } from "@air/redux-selected-items";
import pluralize from "pluralize";
import { useSelector } from "react-redux";
import { BoardCollectionDeleteClipsModal } from "~/components/BoardCollection/BoardCollectionDeleteClipsModal";
import { BoardCollectionGalleryAssetDetailsModal } from "~/components/BoardCollection/BoardCollectionGalleryAssetDetailsModal";
import { boardCollectionFormSelector } from "~/store/boardCollection/selectors";
import { selectedClipsSelector } from "~/store/selectedItems/selectors";
import { getDropdownMenuOption } from "~/utils/menuOptions/getDropdownMenuOption";
import { useAirStore } from "~/utils/ReduxUtils";
export const useGetBoardCollectionGalleryAssetMenuOptions = (param)=>{
    let { clip } = param;
    const store = useAirStore();
    const form = useSelector(boardCollectionFormSelector);
    const [showDeleteClipsModal] = useAirModal(BoardCollectionDeleteClipsModal);
    const [showBoardCollectionGalleryAssetDetailsModal] = useAirModal(BoardCollectionGalleryAssetDetailsModal);
    const getBoardCollectionAssetMenuOptions = ()=>{
        const isSelected = itemIsSelectedSelector(store.getState(), clip.id);
        const selectedCount = selectedItemsCountSelector(store.getState());
        const options = [];
        form.fields.some((field)=>field.type === "custom_field") && options.push({
            ...getDropdownMenuOption("edit"),
            onSelect: ()=>showBoardCollectionGalleryAssetDetailsModal({
                    clips: isSelected ? selectedClipsSelector(store.getState()) : [
                        clip
                    ]
                }),
            type: "item"
        }, {
            id: "edit-separator",
            type: "separator"
        });
        options.push({
            ...getDropdownMenuOption("delete"),
            label: selectedCount ? "Delete ".concat(pluralize("item", selectedCount, true)) : "Delete item",
            onSelect: ()=>{
                const selectedItems = selectedClipsSelector(store.getState());
                return showDeleteClipsModal({
                    clips: isSelected ? selectedItems : [
                        clip
                    ]
                });
            },
            type: "item"
        });
        if (isSelected && selectedCount > 1 && !!options.length) {
            options.unshift({
                id: "selected-header",
                type: "title",
                label: "".concat(pluralize("item", selectedCount, true), " selected")
            }, {
                id: "selected-separator",
                type: "separator"
            });
        }
        return options;
    };
    return {
        getBoardCollectionAssetMenuOptions
    };
};
